import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  header: {
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    fontSize: '1.8rem',
    fontFamily: 'Qanelas-Bold',
    height: '48px',
    marginTop: '16px',
  },
  title: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.light,
    fontSize: '18px',
  },
  row: {
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    gap: '10px',
    marginBottom: '16px',
  },
  scroller: {
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingRight: theme.spacing(2),
    height: '66vh',
    padding: '8px',
  },
}));

interface Props {
  title?: string;
}

const TransactionForInvoiceHeader = (props: Props) => {
  const classes = useStyles();
  const { title } = props;

  return (
    <div className={classes.header}>
      <div className={`${classes.row}`}>
        <Typography
          variant="h5"
          color="secondary"
          gutterBottom
          className={classes.header}>
          {title}
        </Typography>
      </div>
    </div>
  );
};

export default TransactionForInvoiceHeader;
